module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contable/contable.component.css
// module id = ./src/app/components/contable/contable.component.css
// module chunks = main